/**
 * This file is used to over-write jquery default values
 */
define([
    'jquery',
    'jquery/validate'
], function($) {
    'use strict';

    $.extend($.validator.messages, {
        equalTo: "Passwords don't match"
    });
});
